"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DnaRInputType;
(function (DnaRInputType) {
    DnaRInputType[DnaRInputType["text"] = 0] = "text";
    DnaRInputType[DnaRInputType["currency"] = 1] = "currency";
})(DnaRInputType = exports.DnaRInputType || (exports.DnaRInputType = {}));
